import React from "react";
import LazyloadImage from "./LazyloadImage";
import StaticImage from './StaticImage';

export default class ResultCardImage extends React.Component {
  static defaultProps = {
    containerClassName: 'result-card-image-container',
    desktopWidth: 301,
    mobileWidth: 170,
    isLeadImage: false,
    isMobile: false,
    mdCrop: "rs_602.h",
    smCrop: "rs_340.h",
    ariaHidden: 'false',
  };

  render() {
    let { isLeadImage, isMobile } = this.props;

    return (
      isLeadImage && isMobile ? <StaticImage {...this.props} /> : <LazyloadImage {...this.props} />
    )
  }
}
